module.exports = __webpack_public_path__ + "img/poly-2.6e153d28.png";